"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useInitPixels;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _react = require("react");

var _pixelmon = require("../../utils/pixelmon");

var _getContentfulPixelsForApp = _interopRequireDefault(require("../../utils/pixelmon/getContentfulPixelsForApp"));

function useInitPixels(appId, isKidsContent, forcePixelsEnabled, projectId, userId, sessionId, pageViewId) {
  // Set projectId first so that if the registerPixels() call causes queued pixels to fire, projectId has already been set
  // and set all global fields to pixelmon, to be used for injection
  (0, _react.useEffect)(function () {
    (0, _pixelmon.getPixelmonInstance)().setGlobals({
      projectId: projectId,
      appId: appId,
      userId: userId,
      sessionId: sessionId,
      pageViewId: pageViewId
    });
  }, [projectId, appId, userId, sessionId, pageViewId]); // Also declare projectId a dependency so that when projectId changes, pixelmon gets updated with the latest

  (0, _react.useEffect)(function () {
    // (Don't early-return async function from the hook because then useEffect thinks the promise is the teardown function)
    var doInitPixels = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var relevantPixelConfigs;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _getContentfulPixelsForApp["default"])(appId);

              case 2:
                relevantPixelConfigs = _context.sent;
                (0, _pixelmon.getPixelmonInstance)().registerPixels(relevantPixelConfigs);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function doInitPixels() {
        return _ref.apply(this, arguments);
      };
    }(); // Regardless of isKidsContent, forcePixelsEnabled means activate pixelmon!


    if (forcePixelsEnabled === true) {
      doInitPixels();
      return;
    } // We're isKidsContent and don't forcePixelsEnabled, so early return and don't activate pixelmon


    if (isKidsContent === true) {
      return;
    } // There's no isKidsContent to stop us, so activate pixelmon!


    doInitPixels();
  }, [forcePixelsEnabled]); // Once forcePixelsEnabled to true, the pixel init will indeed happen (even if isKidsContent is still true). (The reverse is not handled yet since there's no notion of "disabling" Pixelmon)
}